<template>
  <div class="logo-display">
    <img v-if="logoSrc" :src="logoSrc" alt="Provider Logo" />
    <img
      v-else
      class="logo-default"
      src="@Shared/assets/images/default-provider-logo.svg"
      alt="Provider Logo"
    />
  </div>
</template>

<script>
import base64 from "base-64";

export default {
  name: "LogoDisplay",
  props: {
    logoSrc: {
      type: String,
    },
  },
  computed: {
    decodedLogo() {
      return `data:image/jpg;base64,${base64.decode(this.logoSrc)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-display {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.logo-default {
  height: 50px;
}

img {
  max-width: 100%;
  max-height: 75px;
  mix-blend-mode: darken;
}
</style>
